const normalized = (value) => String(value || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export function supplierDisplayName(supplier) {
  const name = supplier.nome || supplier.name || supplier.label || '';
  const fantasy = supplier.fantasia || supplier.nomeFantasia || supplier.fantasyName || '';
  return fantasy && normalized(fantasy) !== normalized(name) ? `${name} · ${fantasy}` : name;
}

export function proposalGroupOptions(items = []) {
  const groups = new Map();
  items.forEach((item) => {
    const seen = new Set();
    for (const [id, name] of [[item.blingGroupId, item.blingGroupName], [item.blingParentGroupId, item.blingParentGroupName]]) {
      if (!id && !name) continue;
      const type = id ? 'blingGroupId' : 'blingGroupName';
      const source = String(id || name).trim();
      const key = `${type}:${id || normalized(name)}`;
      if (seen.has(key)) continue;
      seen.add(key);
      if (!groups.has(key)) groups.set(key, { key, type, source, name: name || `Grupo ${id}`, id: id || '', count: 0 });
      groups.get(key).count += 1;
    }
  });
  return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
}

export function applyGroupMappings(config, options, selectedKeys, groupId) {
  const selected = options.filter((option) => selectedKeys.includes(option.key));
  const rules = config.rules.filter((rule) => !selected.some((option) => rule.type === option.type &&
    (rule.type === 'blingGroupName' ? normalized(rule.source) === normalized(option.source) : rule.source === option.source)));
  return { ...config, rules: [...rules, ...selected.map((option) => ({ type: option.type, source: option.source, groupId }))] };
}
